export function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

// Method to validate a password with at least 8 characters, 1 uppercase, 1 lowercase, 1 number
export function validatePassword(password) {
  if (!password) return true;
  var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return re.test(password);
}

/*
  Source: https://stackoverflow.com/questions/4059147/check-if-a-variable-is-a-string-in-javascript
*/
export function isString(myVar){
  return (typeof myVar === 'string' || myVar instanceof String)
}

export function isBool(myVar){
  return (typeof myVar === 'boolean' || myVar instanceof Boolean)
}

export function isDate(myVar){
  return(Object.prototype.toString.call(myVar) === "[object Date]")
}
